exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".opacity0[data-v-ec5201ca]{opacity:0}.wrapper-name[data-v-ec5201ca]{display:flex;white-space:nowrap}.wrapper-name .name[data-v-ec5201ca]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
